import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PalantirAccordionComponent } from '../../../../accordion/accordion.component';
import { PalantirIconComponent } from '../../../../icon/icon.component';
import { PalantirInputComponent } from '../../../../input/input.component';
import { PalantirTextComponent } from '../../../../text/text.component';
import type { PalantirFilterModalInstance } from '../../../filter-modal.instance';
import type { PalantirFilterDateInput } from '../../../filter-modal.type';
import { PalantirFilterModalErrorDisplayComponent } from '../../shared/error-display/error-display.component';
import { filterModalInputLogger } from '../logger.instance';

const logger = filterModalInputLogger.extend('date');

@Component({
  selector: 'palantir-filter-modal-date-input-component',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  standalone: true,
  imports: [
    PalantirAccordionComponent,
    PalantirInputComponent,
    ReactiveFormsModule,
    PalantirTextComponent,
    PalantirFilterModalErrorDisplayComponent,
    PalantirIconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalantirFilterModalDateInputComponent {
  public readonly definition = input.required<PalantirFilterDateInput>();

  public readonly control = input.required<FormControl>();

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  public readonly modalInstance = input.required<PalantirFilterModalInstance<{}>>();

  // eslint-disable-next-line unicorn/consistent-function-scoping
  public canShowFilter = computed(() => {
    const canShow = this.modalInstance().dependsOnFilterComputed(this.definition().dependsOn);
    logger.debug(`Visibility check for "${this.definition().label}":`, canShow);
    return canShow;
  });

  public constructor() {
    logger.debug('Component created');
  }
}
